import productEnum from "./modules/productEnum";
import energyEnum from "./modules/energyEnum";

export default {
  productEnum,
  energyEnum
}



// WEBPACK FOOTER //
// ./src/enums/index.js